export const Tick = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0.5C3.808 0.5 0 4.308 0 9C0 13.692 3.808 17.5 8.5 17.5C13.192 17.5 17 13.692 17 9C17 4.308 13.192 0.5 8.5 0.5ZM6.8 13.25L2.55 9L3.7485 7.8015L6.8 10.8445L13.2515 4.393L14.45 5.6L6.8 13.25Z"
        fill="#34D399"
      />
    </svg>
  );
};
